export default __webpack_public_path__ + "static/tokenPermissions-23994bac5fe1f85b64ec13a4519ca31f.png";